import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { setMessage } from './message';

import manualWeightEntryService from '../services/manual-weight-entry.service';


export const fetchManualWeightEntryList = createAsyncThunk(
    'manualWeightEntry/fetchManualWeightEntryList',
    async ({ page, pagesize, search, ordering }, thunkAPI) => {
        try {
            const response = await manualWeightEntryService.getManualWeightEntryList(page, pagesize, search, ordering);
            return response.data;
        } catch (error) {
            const message =
                (error.response &&
                    error.response.data &&
                    error.response.data.message) ||
                error.message ||
                error.toString();
            thunkAPI.dispatch(setMessage(message));
            return thunkAPI.rejectWithValue();
        }
    },
);

export const fetchArchivedManualWeightEntrylist = createAsyncThunk(
    'manualWeightEntry/fetchArchiveManualWeightEntryList',
    async ({ page, pagesize, search, ordering }, thunkAPI) => {
        try {
            const response = await manualWeightEntryService.getArchiveManualWeightEntryList(page, pagesize, search, ordering);
            return response.data;
        } catch (error) {
            const message =
                (error.response &&
                    error.response.data &&
                    error.response.data.message) ||
                error.message ||
                error.toString();
            thunkAPI.dispatch(setMessage(message));
            return thunkAPI.rejectWithValue();
        }
    },
);
export const fetchManualWeightEntryDetails = createAsyncThunk(
    'manualWeightEntry/fetchManualWeightEntryDetails',
    async (id, { rejectWithValue }) => {
        try {
            const response = await manualWeightEntryService.getManualWeightEntryDetails(id);
            return response.data; // Return the profile data
        } catch (error) {
            return rejectWithValue(error.response?.data || error.message);
        }
    }
);
export const fetchManualWeightEntryById = createAsyncThunk(
    'manualWeightEntry/fetchManualWeightEntryById',
    async (manualWeightEntryId, { rejectWithValue }) => {
        try {
            const response = await manualWeightEntryService.getManualWeightEntryById(manualWeightEntryId);
            return response.data; // Return the profile data
        } catch (error) {
            return rejectWithValue(error.response?.data || error.message);
        }
    }
);


export const createManualWeightEntry = createAsyncThunk(
    'manualWeightEntry/createManualWeightEntry',
    async ({ values }, thunkAPI) => {
        try {
            const textPayload = {
                party_name: values.party_name,
                party_code: values.party_code,
                opening_balance: values.opening_balance,
                balance_type: values.balance_type,
                is_this_cash_account: values.is_this_cash_account || false,
                address: values.address,
                city: values.city,
                pincode: values.pincode,
                mobile_sms: values.mobile_sms,
                mobile: values.mobile,
                phone: values.phone,
                email: values.email,
                sms_type: values.sms_type,
                is_active: values.is_active || false,
              };
              
            const response = await manualWeightEntryService.addManualWeightEntry(textPayload);
            return response.data; // Assuming response contains the created manualWeightEntry data
        } catch (error) {
            const message =
                (error.response && error.response.data && error.response.data.message) ||
                error.message ||
                error.toString();
            thunkAPI.dispatch(setMessage(message));
            return thunkAPI.rejectWithValue(message);
        }
    }
);

export const updateManualWeightEntry = createAsyncThunk(
    'manualWeightEntry/updateManualWeightEntry',
    async ({ id, values }, thunkAPI) => {
        try {
            const formPayload = {
                party_name: values.party_name,
                party_code: values.party_code,
                opening_balance: values.opening_balance,
                balance_type: values.balance_type,
                is_this_cash_account: values.is_this_cash_account || false,
                address: values.address,
                city: values.city,
                pincode: values.pincode,
                mobile_sms: values.mobile_sms,
                mobile: values.mobile,
                phone: values.phone,
                email: values.email,
                sms_type: values.sms_type,
                is_active: values.is_active || false,
            };

            const response = await manualWeightEntryService.updateManualWeightEntry(id, formPayload);

            return response.data; // Return the updated manualWeightEntry data
        } catch (error) {
            const message =
                (error.response && error.response.data && error.response.data.message) ||
                error.message ||
                error.toString();
            thunkAPI.dispatch(setMessage(message));
            return thunkAPI.rejectWithValue(message);
        }
    }
);

export const deleteManualWeightEntry = createAsyncThunk(
    'manualWeightEntry/deleteManualWeightEntry',
    async (id, thunkAPI) => {
        try {
            await manualWeightEntryService.deleteManualWeightEntry(id); // Ensure `id` is used here
            return id; // Return the ID of the deleted group
        } catch (error) {
            const message =
                (error.response && error.response.data && error.response.data.message) ||
                error.message ||
                error.toString();
            thunkAPI.dispatch(setMessage(message));
            return thunkAPI.rejectWithValue(message);
        }
    }
);

export const unArchiveManualWeightEntry = createAsyncThunk(
    'manualWeightEntry/unArchiveManualWeightEntry',
    async (id, thunkAPI) => {
        try {
            await manualWeightEntryService.unArchiveManualWeightEntryRecord(id); // Ensure `id` is used here
            return id; // Return the ID of the deleted group
        } catch (error) {
            const message =
                (error.response && error.response.data && error.response.data.message) ||
                error.message ||
                error.toString();
            thunkAPI.dispatch(setMessage(message));
            return thunkAPI.rejectWithValue();
        }
    }
);

const initialState = {
    data: [], // List
    list: [],
    toolsList: [],
    loading: false,
    totalPages: 0,
    currentPage: 1,
    totalRecord: 0,
    status: 'idle',
    error: null,
    hasMore: true,
};


const manualWeightEntrySlice = createSlice({
    name: 'manualWeightEntry',
    initialState,
    reducers: {
        setLoading: (state, action) => {
            state.loading = action.payload;
        },
        resetManualWeightEntryData: (state) => {
            state.data = []; // This will clear the list
        },
        resetManualWeightEntryList: (state) => {
            state.list = []; // This will clear the list
        },
        // resetToolsList: (state) => {
        //     state.toolsList = []; // This will clear the list
        // },
        resetCurrentManualWeightEntryPage: (state) => {
            state.currentPage = 1;
        }
    },
    extraReducers: builder => {
        builder
            .addCase(fetchManualWeightEntryList.pending, (state) => {
                state.status = 'loading';
            })
            .addCase(fetchManualWeightEntryList.fulfilled, (state, action) => {
                state.status = 'succeeded';
                const fetchedPage = action.payload.page || state.currentPage;
                state.data = action.payload.results.data || [];
                state.totalPages = action.payload.totalPages;
                state.totalRecord = action.payload.count;
                state.currentPage = action.payload.next ? fetchedPage + 1 : fetchedPage;
                state.list = [...state.list, ...action.payload.results.data];
                state.hasMore = !!action.payload.next;
            })
            .addCase(fetchManualWeightEntryList.rejected, (state, action) => {
                state.status = 'failed';
                state.loading = false;
                state.error = action.error.message;
            });
        builder
            .addCase(fetchArchivedManualWeightEntrylist.pending, (state) => {
                state.status = 'loading';
            })
            .addCase(fetchArchivedManualWeightEntrylist.fulfilled, (state, action) => {
                state.status = 'succeeded';
                const fetchedPage = action.payload.page || state.currentPage;
                state.data = action.payload.results.data || [];  // Update to match your API response
                state.totalRecord = action.payload.count || 0; // Handle count (total records)
                state.totalPages = action.payload.totalPages || 0; // Handle totalPages
                state.currentPage = action.payload.next ? fetchedPage + 1 : fetchedPage;
                state.list = [...state.list, ...action.payload.results.data];
                state.hasMore = !!action.payload.next;
            })
            .addCase(fetchArchivedManualWeightEntrylist.rejected, (state, action) => {
                state.status = 'failed';
                state.loading = false;
            });

        builder
            .addCase(fetchManualWeightEntryDetails.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(fetchManualWeightEntryDetails.fulfilled, (state, action) => {
                state.loading = false;
            })
            .addCase(fetchManualWeightEntryDetails.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
            });

        builder
            .addCase(fetchManualWeightEntryById.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(fetchManualWeightEntryById.fulfilled, (state, action) => {
                state.loading = false;
            })
            .addCase(fetchManualWeightEntryById.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
            });


        builder
            .addCase(createManualWeightEntry.pending, state => {
                state.status = 'loading';
            })
            .addCase(createManualWeightEntry.fulfilled, (state, action) => {
                state.status = 'succeeded';
            })
            .addCase(createManualWeightEntry.rejected, (state, action) => {
                state.status = 'failed';
                state.error = action.payload;
            });
        builder
            .addCase(updateManualWeightEntry.pending, state => {
                state.status = 'loading';
            })
            .addCase(updateManualWeightEntry.fulfilled, (state, action) => {
                state.status = 'succeeded';
            })
            .addCase(updateManualWeightEntry.rejected, (state, action) => {
                state.status = 'failed';
                state.error = action.payload;
            });
        builder
            .addCase(deleteManualWeightEntry.pending, state => {
                state.status = 'loading';
            })
            .addCase(deleteManualWeightEntry.fulfilled, (state, action) => {
                state.status = 'succeeded';
                state.data = state.data.filter(group => group.id !== action.payload); // Remove the deleted group from state
                state.list = state.list.filter(group => group.id !== action.payload); // Remove the deleted group from list
            })
            .addCase(deleteManualWeightEntry.rejected, (state, action) => {
                state.status = 'failed';
                state.loading = false;
                state.error = action.payload;
            });
        builder
            .addCase(unArchiveManualWeightEntry.pending, state => {
                state.status = 'loading';
            })
            .addCase(unArchiveManualWeightEntry.fulfilled, (state, action) => {
                state.status = 'succeeded';
                state.data = state.data.filter(group => group.id !== action.payload); // Remove the deleted group from state
            })
            .addCase(unArchiveManualWeightEntry.rejected, (state, action) => {
                state.status = 'failed';
                state.loading = false;
                state.error = action.error.message;
            });
    },
});

export const { resetManualWeightEntryList, resetManualWeightEntryData,  resetCurrentManualWeightEntryPage } = manualWeightEntrySlice.actions;
const { reducer } = manualWeightEntrySlice;
export default reducer;
